<template>
  <div class="WechatUsers">
    <div class="topselect">
      <header>
        <!-- <el-input v-model="wechatUsersQuery.channel_code" placeholder="渠道号名称" style="width: 200px; margin-right: 10px;" /> -->
        <el-select
          v-model="wechatUsersQuery.platform_id"
          placeholder="请选择平台"
          filterable
          :clearable="true"
          @clear="clean"
          @change="alew"
        >
          <el-option
            v-for="(item, index) in platformSelectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-select
          v-model="wechatUsersQuery.novel_id"
          placeholder="请选择书籍"
          filterable
          :clearable="true"
          @focus="getbooks"
        >
          <el-option
            v-for="(item, index) in bookList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-input
          v-model="wechatUsersQuery.channel_code"
          placeholder="渠道号"
          style="width: 200px; margin-right: 10px"
        />
        <el-button
          type="primary"
          style="margin-right: 5px; margin-left:10px"
          icon="el-icon-search"
          @click="search"
        >搜索</el-button>
        <el-button
          type="primary"
          icon="el-icon-refresh"
          @click="reset"
        >重置</el-button>
        <el-button
          type="primary"
          icon="el-icon-download"
          style="margin-left:10px"
          @click="exportChannelReport"
        >导出</el-button>

        <!-- <el-button type="primary" @click="showDaysOrNot = !showDaysOrNot">
          {{ showDaysOrNot ? '收起天数' : '展开天数' }}
        </el-button> -->
      </header>
    </div>
    <main>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="日期"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="optimizers"
          label="优化师"
          min-width="100"
          align="center"
        >
          <template scope="scope">
            <span
              style="min-width: 100px;overflow:hidden;white-space: nowrap; text-overflow: ellipsis;"
              :style="{ whiteSpace: scope.row.optimizers.join('、').includes('、') && openOptimizers.includes(scope.row.id) ? 'break-spaces' : 'nowrap'}"
              :title="scope.row.optimizers.join('、')"
            >{{
              scope.row.optimizers.includes('、') ? openOptimizers.includes(scope.row.id) ? scope.row.optimizers.join('、').split('、').join('\n') : scope.row.optimizers.join('、') : scope.row.optimizers.join('、')
            }}</span>
            <p
              v-if="scope.row.optimizers.join('、').includes('、')"
              style="cursor: pointer; color: #0088ff;"
              @click="openOptimizers.includes(scope.row.id) ?
                openOptimizers = openOptimizers.filter(id => id !== scope.row.id) :
                openOptimizers.push(scope.row.id)"
            >{{ openOptimizers.includes(scope.row.id) ? '收起' : '展开' }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="channels"
          label="渠道号"
          min-width="200"
          align="center"
        >
          <template scope="scope">
            <span
              style="min-width: 100px;overflow:hidden;white-space: nowrap; text-overflow: ellipsis;"
              :style="{ whiteSpace: scope.row.channels.join('、').includes('、') && openChannels.includes(scope.row.id) ? 'break-spaces' : 'nowrap'}"
              :title="scope.row.channels.join('、')"
            >{{
              scope.row.channels.includes('、') ? openChannels.includes(scope.row.id) ? scope.row.channels.join('、').split('、').join('\n') : scope.row.channels.join('、') : scope.row.channels.join('、')
            }}</span>
            <p
              v-if="scope.row.channels.join('、').includes('、')"
              style="cursor: pointer; color: #0088ff;"
              @click="openChannels.includes(scope.row.id) ?
                openChannels = openChannels.filter(id => id !== scope.row.id) :
                openChannels.push(scope.row.id)"
            >{{ openChannels.includes(scope.row.id) ? '收起' : '展开' }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="channel_names"
          label="渠道名称"
          min-width="200"
          align="center"
        >
          <template scope="scope">
            <span
              style="min-width: 100px;overflow:hidden;white-space: nowrap; text-overflow: ellipsis;"
              :style="{ whiteSpace: scope.row.channel_names.join('、').includes('、') && openChannelNames.includes(scope.row.id) ? 'break-spaces' : 'nowrap'}"
              :title="scope.row.channel_names.join('、')"
            >{{
              scope.row.channel_names.includes('、') ? openChannelNames.includes(scope.row.id) ? scope.row.channel_names.join('、').split('、').join('\n') : scope.row.channel_names.join('、') : scope.row.channel_names.join('、')
            }}</span>
            <p
              v-if="scope.row.channel_names.join('、').includes('、')"
              style="cursor: pointer; color: #0088ff;"
              @click="openChannelNames.includes(scope.row.id) ?
                openChannelNames = openChannelNames.filter(id => id !== scope.row.id) :
                openChannelNames.push(scope.row.id)"
            >{{ openChannelNames.includes(scope.row.id) ? '收起' : '展开' }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="novels"
          label="书籍名称"
          min-width="100"
          align="center"
        >
          <template scope="scope">
            <span
              style="min-width: 100px;overflow:hidden;white-space: nowrap; text-overflow: ellipsis;"
              :style="{ whiteSpace: scope.row.novels.join('、').includes('、') && openNovels.includes(scope.row.id) ? 'break-spaces' : 'nowrap'}"
              :title="scope.row.novels.join('、')"
            >{{
              scope.row.novels.includes('、') ? openNovels.includes(scope.row.id) ? scope.row.novels.join('、').split('、').join('\n') : scope.row.novels.join('、') : scope.row.novels.join('、')
            }}</span>
            <p
              v-if="scope.row.novels.join('、').includes('、')"
              style="cursor: pointer; color: #0088ff;"
              @click="openNovels.includes(scope.row.id) ?
                openNovels = openNovels.filter(id => id !== scope.row.id) :
                openNovels.push(scope.row.id)"
            >{{ openNovels.includes(scope.row.id) ? '收起' : '展开' }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="platform"
          label="平台"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="total_cost"
          label="总消耗"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="new_num"
          label="新用户"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="new_unit"
          label="新增单价"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="new_recharge"
          label="新用户充值"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="new_roi"
          label="新用户roi"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="total_recharge"
          label="累积充值"
          min-width="100"
          align="center"
        />
        <el-table-column
          prop="pay_growth_rate"
          label="总回本"
          min-width="100"
          align="center"
        />
      </el-table>
    </main>
    <add-account-drawer ref="addAccountDrawer" />
    <!-- <el-dialog title="导出报表" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" @close="timesr = ''">
      <el-date-picker
        v-model="timesr"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions1"
        :default-value="timeDefaultShow"
        @click.once="changeInitCalendarPage"
      />
      <div style="margin-top:30px;display: flex;justify-content: flex-end;">
        <el-button type="primary" @click="exportChannelReport">确定</el-button>
      </div>

    </el-dialog> -->
    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import addAccountDrawer from '@/views/report/channelListcompent/components/addAccountDrawer.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import {
  getchannelplatform
} from '@/api/report/wechatUsers.js'
import { getList, exportChannelGeneralReport } from '@/api/report/channelTotalReport.js'
import { novelListScreen } from '@/api/providerAccountManagement/WeChatAccountFans'
export default {
  name: 'GeneralChannelReport',
  components: {
    PaginationRight,
    addAccountDrawer
  },
  data() {
    return {
      tableData: {},
      platformSelectList: [], // 获取平台数据列表
      openChannels: [],
      openChannelNames: [],
      openNovels: [],
      openOptimizers: [],
      showDaysOrNot: false,
      wechatUsersQuery: {
        platform_id: undefined, // 平台id
        channel_code: undefined, // 渠道号
        channel_name: undefined, // 渠道名称
        optimizer: undefined, // 优化师
        novel_id: undefined, // 书籍
        date: this.getNowTime(), // 时间
        page: 1, // 分页
        page_size: 10 // 页数据量
      },
      bookList: [],
      timesr: '',
      timeDefaultShow: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > (Date.now() - (24 * 60 * 60 * 1000))
        }
      },
      pickerOptions1: {
        disabledDate(v) {
          return (
            v.getTime() >
            new Date().getTime() - (86400000 - 24 * 60 * 60 * 1000) - (24 * 60 * 60 * 1000)
          )
        }
      },
      loading: false, // 加载效果
      dialogVisible: false,
      maxLength: 0
    }
  },
  created() {
    this.getListData()
    this.getpingtai()
  },
  methods: {

    // 关闭选择平台
    clean() {
      this.wechatUsersQuery.platform_id = undefined
      this.wechatUsersQuery.channel_code = undefined
      this.wechatUsersQuery.novel_id = undefined
      this.bookList = []
      this.getListData()
    },

    // 日期选择器，点击事件处理某些东西
    changeInitCalendarPage() {
      const dom = document.querySelector('button.button.el-picker-panel__icon-btn.el-icon-arrow-left')
      if (dom) {
        dom.click()
      }
    },

    // 获取书籍
    async getbooks() {
      let text = null
      if (!this.wechatUsersQuery.platform_id) {
        text = '请选择平台'
      }
      if (text) {
        this.$message({
          message: text,
          type: 'warning'
        })
      } else {
        const data = await novelListScreen({ platform_id: this.wechatUsersQuery.platform_id })
        this.bookList = data.data.list
      }
    },

    // 获取平台数据
    getpingtai() {
      this.loading = true
      getchannelplatform().then((res) => {
        this.platformSelectList = res.data.list
        this.loading = false
      })
    },
    // 获取列表数据
    getListData() {
      this.loading = true

      getList({
        ...this.wechatUsersQuery,
        start_date: this.timesr ? this.timesr[0] : null,
        end_date: this.timesr ? this.timesr[1] : null
      }).then((res) => {
        res.data.list.forEach((item) => {
          item.id = Math.random()
        })
        this.tableData = res.data

        // this.data.startTime = res.data.list.created_at
        // this.data.endTime = res.data.list.end_time
        this.loading = false
      })
    },
    // 点击新增回调
    handle() {
      this.dialogVisible = false
      this.getListData()
    },
    // 分页
    fetchPageSize(e) {
      this.wechatUsersQuery.page_size = e
      this.getListData()
    },
    // 分页
    fetchCurrentPage(e) {
      this.wechatUsersQuery.page = e
      this.getListData()
    },
    // 搜索数据
    search() {
      this.wechatUsersQuery.page = 1
      this.getListData()
    },
    // 重置搜索框
    reset() {
      this.wechatUsersQuery = {
        platform_id: undefined,
        channel_code: undefined,
        channel_name: undefined,
        optimizer: undefined,
        novel_id: undefined,
        date: this.getNowTime(),
        page: 1,
        page_size: this.wechatUsersQuery.page_size
      }
      this.timesr = ''
      this.getListData()
    },

    // 导出报表
    async exportChannelReport() {
      const bool = this.judge(this.wechatUsersQuery, this.timesr)

      if (!bool) {
        return
      }
      const data = await exportChannelGeneralReport({
        channel_code: this.wechatUsersQuery.channel_code,
        platform_id: this.wechatUsersQuery.platform_id,
        optimizer: this.wechatUsersQuery.optimizer,
        novel_id: this.wechatUsersQuery.novel_id
        /* start_date: this.getYesterday(),
        end_date: this.getYesterday() */
      })
      this.$message({
        message: `导出成功，任务ID为：${data.data.task_id}`,
        type: 'success'
      })
      this.dialogVisible = false
      this.reset()
    },

    // 判断数据是否为空
    judge(wechatUsersQuery, timesr) {
      let text = null
      if (!wechatUsersQuery.platform_id) {
        text = '请选择平台'
      } /* else if (!wechatUsersQuery.channel_code) {
        text = '请输入渠道号'
      } else if (!wechatUsersQuery.optimizer) {
        text = '请输入优化师'
      } else if (timesr === null || !timesr.length) {
        text = '请选择日期'
      }*/

      if (text) {
        this.$message({
          message: text,
          type: 'warning'
        })
        return false
      }
      return true
    },

    // 平台
    alew() {
      this.wechatUsersQuery.channel_code = null
    },

    // 时间
    getNowTime() {
      var now = new Date()
      var year = now.getFullYear() // 得到年份
      var month = now.getMonth() // 得到月份
      var date = now.getDate() // 得到日期
      // var hour = ' 00:00:00' // 默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      var defaultDate = `${year}-${month}-${date}`
      console.log(defaultDate)
      return undefined
    },

    getYesterday() {
      const date = new Date()
      const month = date.getMonth() + 1
      const day = date.getDate() - 1
      return `${date.getFullYear()}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
    }
  }
}
</script>

<style scoped lang="less">
.add {
  margin-left: 20px;
}
.topselect {
  display: flex;
}
.WechatUsers {
  min-width: 1200px;
  padding: 30px 60px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}
</style>
